import React from "react";
import CaprimLogo from '../../assets/images/brand/Imagotipo-horizontal.png';

const Innerpage = () => {
    return (
        <>
            <div className="inner-page-hero inner-page-hero--contacto">
                <div className="container">
                    <div className="inner-page-hero--contacto-row">
                        <div className="inner-page-hero--contacto-text">
                            <div className="hero-heading-title">
                                <h2>Contáctanos</h2>
                            </div>
                        </div>
                        <img
                            className="inner-page-hero--contacto-logo"
                            src={CaprimLogo}
                            alt="Caprim"
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
export default Innerpage;